import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import API from "../../Network/API";

const LiveAudioPulseBar = () => {
    const [liveRooms, setLiveRooms] = useState([]);
    const refreshIntervalRef = useRef(null);

    const fetchLiveRooms = async () => {
        try {
            // Audio rooms only for now — video streams stay hidden from the home
            // feed until the mobile app ships with video support (the backend
            // defaults to type=audio when no type param is sent).
            const res = await API.get('/v1/audio-rooms?status=live');
            if (res.data?.success) {
                setLiveRooms(res.data.data);
            }
        } catch (error) {
            console.error("Failed to fetch live audio rooms:", error);
        }
    };

    useEffect(() => {
        // Initial fetch
        fetchLiveRooms();

        // Background polling every 30 seconds
        refreshIntervalRef.current = setInterval(() => {
            fetchLiveRooms();
        }, 30000);

        return () => {
            if (refreshIntervalRef.current) {
                clearInterval(refreshIntervalRef.current);
            }
        };
    }, []);

    if (liveRooms.length === 0) {
        return null;
    }

    return (
        <div className="live-audio-pulse-bar" style={{
            background: "#fff",
            borderRadius: "15px",
            border: "1px solid #eee",
            padding: "16px",
            marginBottom: "15px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
        }}>
            <h6 style={{ fontSize: "14px", fontWeight: "bold", margin: "0 0 12px 0", color: "#333" }}>
                Live Audio Rooms ({liveRooms.length} Active)
            </h6>
            <div style={{ display: "flex", overflowX: "auto", paddingBottom: "5px" }}>
                {liveRooms.map((room) => {
                    const host = room.host;
                    
                    const base = API.defaults.baseURL;
                    const avatarUrl = host?.image 
                        ? (host.image.startsWith('http') ? host.image : `${base?.replace('/api', '')}/storage/avatar/${host.image}`)
                        : null;

                    const isVideoStream = room.room_type === 'video';
                    return (
                        <Link
                            key={room.id}
                            to={isVideoStream ? `/live-stream/join/${room.id}` : `/audio-rooms`}
                            style={{ textDecoration: "none", color: "inherit", display: "flex", flexDirection: "column", alignItems: "center", marginRight: "16px" }}
                        >
                            <div style={{
                                width: "58px",
                                height: "58px",
                                borderRadius: "50%",
                                background: isVideoStream
                                    ? "linear-gradient(to bottom right, #E11D48, #F97316)"
                                    : "linear-gradient(to bottom right, #8B2BFF, #FF2BDA)",
                                padding: "3px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <div style={{
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "50%",
                                    background: "#fff",
                                    padding: "2px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                    {avatarUrl ? (
                                        <img 
                                            src={avatarUrl}
                                            alt={host?.name || "User"}
                                            style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }}
                                            onError={(e) => { 
                                                e.target.onerror = null; 
                                                e.target.src = '/img/no-user.jpg'; 
                                            }}
                                        />
                                    ) : (
                                        <div style={{ width: "100%", height: "100%", borderRadius: "50%", background: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <i className="fa fa-user" style={{ color: "#aaa", fontSize: "20px" }}></i>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <span style={{ fontSize: "11px", fontWeight: "600", marginTop: "6px", width: "65px", textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {host?.name ? host.name.split(' ')[0] : 'User'}
                            </span>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default LiveAudioPulseBar;
